import React, { ReactElement } from 'react';
import { Icon } from '@shootsta/common-react';

const Loading = (): ReactElement => (
  <Icon name="shootstagrad" size={40} color="black" spin />
);

export default Loading;
